const MINUTE_MS = 60_000;
const HOUR_MS = 60 * MINUTE_MS;
const DAY_MS = 24 * HOUR_MS;

export const formatJobUpdatedTime = (date: string | Date | null | undefined, now = Date.now()): string | null => {
    if (!date) return null;
    const updatedAt = date instanceof Date ? date.getTime() : Date.parse(date);
    const elapsed = now - updatedAt;
    if (!Number.isFinite(elapsed) || elapsed < 0) return null;

    const days = Math.floor(elapsed / DAY_MS);
    if (days > 7) return null;
    if (days === 7) return 'לפני שבוע';
    if (days === 2) return 'לפני יומיים';
    if (days === 1) return 'לפני יום';
    if (days > 0) return `לפני ${days} ימים`;

    const hours = Math.floor(elapsed / HOUR_MS);
    if (hours === 2) return 'לפני שעתיים';
    if (hours === 1) return 'לפני שעה';
    if (hours > 0) return `לפני ${hours} שעות`;

    const minutes = Math.floor(elapsed / MINUTE_MS);
    if (minutes === 1) return 'לפני דקה';
    if (minutes > 0) return `לפני ${minutes} דקות`;
    return 'לפני פחות מדקה';
};
